import styled, { css } from 'styled-components';
import { color, whiteSpace, textAlign, margin, uppercase, width, padding, height } from '@10d/tend-ui-styling';
import { INTERNAL_TypographyBase } from '../Base.js';

const Root = styled(INTERNAL_TypographyBase).attrs({
    $levels: {
        h1: css `
      line-height: 1.2;
      font-weight: 700;
    `,
        h2: css `
      line-height: 1.25;
      font-weight: 700;
    `,
        h3: css `
      line-height: 36px;
      font-weight: 700;
    `,
        h4: css `
      line-height: 32px;
      font-weight: 700;
    `,
        h5: css `
      line-height: 24px;
      font-weight: 700;
    `,
        h6: css `
      font-size: 16px;
      line-height: 20px;
      margin-top: 1.2em;
      margin-bottom: 0.5em;
      font-weight: 700;
    `,
        d1: css `
      font-size: 64px;
      line-height: 1.25;
      font-weight: 700;
    `,
        d2: css `
      font-size: 56px;
      font-weight: 400;
      line-height: 1.28;
    `,
    },
}) `
  &&& {
    ${props => props.$levels[props.$level]};
    ${color};
    ${whiteSpace};
    ${textAlign};
    ${margin};
    ${uppercase};
    ${width};
    ${padding};
    ${height};
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
